import { BoxProgrammationImportProgramSelection } from "@modules/boxB2BProgram/components/boxProgrammationImportProgramSelection"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"

export const useProgrammationSessionImportSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()
  const canManageProgramming = useBoxStaffPermission(BoxStaffPermissions.MANAGE_PROGRAMMING)

  const navigateToImportProgramSelection = (programmationId: string, startDate: string, endDate: string) => {
    // PERMISSIONS - Head-coach && Coach & Financial permissions denied
    if (!canManageProgramming) {
      return null
    }

    sidebarNavigateTo({
      content: (
        <BoxProgrammationImportProgramSelection
          programmationId={programmationId}
          startDate={startDate}
          endDate={endDate}
        />
      ),
      replaceAllComponents: true,
    })
  }

  return { navigateToImportProgramSelection }
}
